import type { AccountSourceList, CoprincipalAccountSource, } from "../store/schema/AccountSourceList";

export type AccountAndIndex = {
    account: CoprincipalAccountSource;
    index: number;
};

export function getAccountAndIndexForSourceId(store: AccountSourceList, sourceId: string): AccountAndIndex | undefined {
    const index = store.sources.findIndex(account => account.sourceId === sourceId);
    if (index === -1) {
        return undefined;
    }
    
    return {
        account: store.sources[index],
        index,
    };
}
